import React from "react"

// Launch promo hero. Scarcity headline + new-webshop framing. The CTA
// goes to plain /users/sign_up — the discount rides on the
// shopshift_promo cookie set by HomeController#launch, so no URL
// params are needed.
//
// Less tech, more new-webshop register: addresses founders who just
// launched a webshop, can't afford a CRO consultant, and want
// something that works while they focus on the rest of the business.
export default function LaunchHero({ promoCode, spotsRemaining, spotsTotal }) {
  const safeRemaining = typeof spotsRemaining === "number" ? spotsRemaining : spotsTotal
  const claimed = typeof safeRemaining === "number" ? spotsTotal - safeRemaining : 0

  return (
    <section className="max-w-6xl mx-auto px-6 pt-24 pb-24">
      <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-[color:var(--color-ai)] mb-8">
        § 01 · Launch offer · {spotsTotal || 100} webshops only
      </p>

      <h1 className="font-sans font-medium text-[color:var(--color-ink-primary)] tracking-[-0.045em] leading-[0.95]"
          style={{ fontSize: "clamp(56px, 9vw, 120px)" }}>
        50% off the first three months.
      </h1>
      <p className="mt-6 font-sans text-[24px] tracking-[-0.02em] text-[color:var(--color-ink-secondary)] max-w-3xl leading-[1.3]">
        Just launched your webshop? Get 30 days free, then half price for the next three. We do the conversion work — you stay focused on the product.
      </p>

      <div className="mt-10 flex items-baseline gap-x-8 gap-y-2 flex-wrap font-mono text-[12px] tracking-[0.04em] text-[color:var(--color-ink-tertiary)]">
        <span className="inline-flex items-center gap-2">
          <span
            className="inline-block w-1.5 h-1.5 rounded-full bg-[color:var(--color-winner-dot)]"
            style={{ animation: "pulse 2s ease-in-out infinite" }}
          />
          {claimed} of {spotsTotal || 100} webshops claimed
        </span>
        <span className="text-[color:var(--color-ink-faint)]">·</span>
        <span>No specialist needed</span>
        <span className="text-[color:var(--color-ink-faint)]">·</span>
        <span>Cancel any time</span>
      </div>

      <div className="mt-14 flex items-center gap-4 flex-wrap">
        <a
          href="/users/sign_up"
          className="inline-flex items-center bg-[color:var(--color-brand)] text-white font-sans text-[15px] font-medium px-6 py-3.5 rounded-[var(--radius-button)] hover:opacity-90 transition-opacity"
        >
          Claim your spot — start free
        </a>
        <a
          href="#how-it-works"
          className="font-sans text-[14px] font-medium text-[color:var(--color-ai)] hover:underline"
        >
          How it works →
        </a>
      </div>

      <div className="mt-6 inline-flex items-center gap-3 font-mono text-[11px] tracking-[0.04em] text-[color:var(--color-ink-faint)]">
        <span>Code</span>
        <span className="inline-block px-2 py-1 rounded-[var(--radius-pill)] bg-[color:var(--color-ai-fill)] text-[color:var(--color-ai)] tracking-[0.10em]">
          {promoCode}
        </span>
        <span>applied automatically at checkout · 30 days free first</span>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
      `}</style>
    </section>
  )
}
